import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Congratulations',
  subtitle: 'Your subscription is now active',
  trialActive: 'Your trial is now active',
  updateSuccess:
    'Your subscription was successfully updated. Your card has now been charged.',
  updateInfo: 'You can access transaction details through your invoices list.',
  whatsNext: 'What’s next?',
  cardText1: 'Start creating with tapybl!',
  cardText2: 'Build your first microlesson or AI assistant.',
  goToWorkspace: 'Go to workspace',
  paymentSubtitle: 'Your payment method has been successfully updated',
  paymentInfo:
    'Enter your workspace to create your next course and share it with your learners!',
};

const welsh = {
  title: 'Llongyfarchiadau',
  subtitle: 'Mae eich prawf un flwyddyn bellach yn weithredol',
  trialActive: 'Mae eich treial bellach yn weithredol',
  updateSuccess:
    'Diweddarwyd eich tanysgrifiad yn llwyddiannus. Mae eich cerdyn bellach wedi cael ei dalu.',
  updateInfo: 'Gallwch gyrchu manylion y trafodion trwy eich rhestr anfonebau',
  whatsNext: 'Beth Sydd nesaf?',
  cardText1: 'Dechreuwch greu gyda tapybl!',
  cardText2: 'Adeiladu eich microlesson neu gynorthwyydd AI cyntaf',
  goToWorkspace: "Ewch I'r gweithle",
  paymentSubtitle: "Mae eich dull talu wedi'i ddiweddaru'n llwyddiannus",
  paymentInfo:
    "Mewngofnodwch i'ch Gweithle i greu eich cwrs nesaf a'i rannu gyda'ch dysgwyr!",
};

export const subscriptionSuccessText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
